/* eslint-disable @typescript-eslint/no-explicit-any */
// SlideShow.js
import React, { useEffect, useState, useRef, Fragment } from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';
import colors from '../../Theming/colors';
import { Trans, useTranslation } from 'react-i18next';
import { themeColor } from '../../Theming';

const Container = styled.div`
  width: 321px;
  overflow: hidden;
  position: relative;
  margin-top: 15px;
`;

const Slides = styled.div<{ activeIndex: number }>`
  display: flex;
  transition: transform 0.3s;
  transform: translateX(${(props) => -props.activeIndex * 100}%);
`;

const Slide = styled.div`
  min-width: 321px;
  mn-height: 247px;
`;

const PillsContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 5px;
`;

const Pill = styled.div<{ active: boolean; sliide?: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${(props) =>
    props.active
      ? colors.discountsPurple
      : colors.samsungActivationPillDarkGrey};
`;

const StyledImage = styled.img`
  width: 320px;
`;

const SubTextContainer = styled.div`
  color: ${themeColor('black')};
  font-size: 13px;
  width: 321px;
  height: 45px;
  margin-top: -10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

const SubText = styled.p<{ maxWidth: number }>`
  max-width: ${(props) => props.maxWidth}px;
`;

const PostActivationSlide: React.FC = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [startX, setStartX] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const slides = [
    images.samsung_activation_deals_found,
    images.samsung_activation_you_saved_so_far,
    images.samsung_activation_you_saved,
  ];

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleTouchStart = (e: any) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e: any) => {
    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;

    if (deltaX > 50 && activeIndex > 0) {
      setActiveIndex((prev) => prev - 1);
    } else if (deltaX < -50 && activeIndex < slides.length - 1) {
      setActiveIndex((prev) => prev + 1);
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  return (
    <div>
      <Container onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
        <Slides activeIndex={activeIndex}>
          {slides.map((img, index) => (
            <Slide key={index}>
              <StyledImage src={img} alt={`Slide ${index}`} />
            </Slide>
          ))}
        </Slides>
        <PillsContainer>
          {slides.map((_, index) => (
            <Pill
              key={index}
              active={index === activeIndex}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </PillsContainer>
      </Container>
      <SubTextContainer>
        <SubText maxWidth={400}>
          {t('samsung.activation.slideStep' + (activeIndex + 1))
            .split('\n')
            .map((item, key) => (
              <Fragment key={key + activeIndex}>
                {item} <br />
              </Fragment>
            ))}
        </SubText>
      </SubTextContainer>
    </div>
  );
};

export default PostActivationSlide;
